import {Text, View} from '@react-pdf/renderer'
import {styles} from './Styles'
import {getOutreachLegends, visualOptions} from '../../../helper'

const houseHoldLegendCircle = <View style={styles.houseHoldLegendDot} />

const getOutreachSimulationHouseholdLegendCircle = (type) => (
  <View
    style={{
      ...styles.houseHoldLegendDot,
      ...(type === 'enrolled' ? styles.enrolledHouseholdDot : styles.notEnrolledHouseholdDot)
    }}
  />
)

const getHouseholdLegends = (selectedFocusLayer) => {
  return selectedFocusLayer === 'none' ? null : (
    <View style={styles.houseLegendContainer}>
      {houseHoldLegendCircle}
      <Text style={styles.textRegular}>
        {selectedFocusLayer === visualOptions[1].value ? 'Individual Households' : 'Concentration of Households'}
      </Text>
    </View>
  )
}

/**
 * HouseholdLegend component for PDF export
 * Updated to work with new filter management system
 *
 * @param {string} selectedFocusLayer - Selected focus layer ('none', 'concentration', etc.)
 * @param {Object} outreachData - Outreach data from useOutreachFilters hook
 *   Format: { isActive, type, enrolledValue, selectedOptions, ... }
 * @returns {JSX.Element|null} Household legend for PDF
 */
export const HouseholdLegend = (selectedFocusLayer, outreachData) => {
  // Check if outreach is active using new format
  const isOutreachActive = outreachData?.isActive || false

  return isOutreachActive ? (
    <View style={styles.houseLegendContainer} break='avoid'>
      {selectedFocusLayer === 'none'
        ? null
        : getOutreachLegends(outreachData?.type, outreachData?.enrolledValue, selectedFocusLayer).map((legend) => {
            return (
              <View style={styles.houseLegendItem} key={legend.type}>
                {getOutreachSimulationHouseholdLegendCircle(legend.type)}
                <Text style={styles.textRegular}>{legend.legendText}</Text>
              </View>
            )
          })}
    </View>
  ) : (
    getHouseholdLegends(selectedFocusLayer)
  )
}

/**
 * Check if outreach is enrolled/active
 * Updated to work with new filter management system
 *
 * @param {Object} outreachData - Outreach data from useOutreachFilters hook
 *   Format: { isActive, selectedOptions, ... }
 * @returns {boolean} True if any outreach option is selected
 */
export const isEnrolled = (outreachData) => {
  if (!outreachData) {
    return false
  }
  // New format: check isActive or selectedOptions array
  return outreachData.isActive || (outreachData.selectedOptions && outreachData.selectedOptions.length > 0)
}

/**
 * List of functions and their purpose:
 *
 * - getOutreachSimulationHouseholdLegendCircle: Renders a legend circle for outreach simulation households based on enrollment type.
 * - getHouseholdLegends: Renders legends for household visualization based on the selected focus layer.
 * - HouseholdLegend: Dynamically renders household legends based on outreach data and focus layer selection.
 * - isEnrolled: Checks if outreach is active using new filter management system format.
 */
